import React, { useContext, useEffect, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import FilterData from "./FilterData";
import { ProductContext } from "../../context/ProductContext";
import { useTranslation } from "react-i18next";
const slideInFromRight = keyframes`
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(0);
  }
`;
const slideOutRight = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
`;
const fadeScaleIn = keyframes`
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

// Na desktopu (>=1040px) dugme + panel dele ovaj position:relative kontekst
// tako da se panel usidri direktno ispod dugmeta (dropdown), umesto pune
// bočne fioke koja se prostire preko celog ekrana kao na mobilnom/tabletu.
const RelativeAnchor = styled.div`
  position: relative;
  display: inline-block;
`;

// Ovi overlay-i moraju biti iznad --zindex-top (9999) koji koristi glavni
// sticky header sajta, jer Filter (za razliku od hamburger menija) NIJE
// ugnježden unutar Header-a - bez ovoga gornji deo panela (naslov, X dugme)
// bio bi vizuelno sakriven ispod headera.
const OVERLAY_Z = 10001;

// Nevidljivi full-screen "hvatač" klika za zatvaranje dropdown-a klikom bilo
// gde van njega - na mobilnom/tabletu tu ulogu (i zatamnjenje) igra Container.
const DesktopClickCatcher = styled.div`
  display: none;
  @media (min-width: 1040px) {
    display: ${(props) => (props.$isOpen ? "block" : "none")};
    position: fixed;
    inset: 0;
    background: transparent;
    z-index: ${OVERLAY_Z - 1};
  }
`;

const ContainerX = styled.div``;
const Container = styled.div`
  margin-top: var(--spacing-xxs);
  background-color: rgba(15, 17, 20, 0.55);
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${OVERLAY_Z};
  min-width: 100%;
  height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  transition: opacity 300ms ease-in-out;
  visibility: ${(props) => (props.$shouldBeVisible ? "visible" : "hidden")};

  @media (min-width: 1040px) {
    position: absolute;
    background-color: transparent;
    height: auto;
    min-width: 0;
    left: 0;
    top: calc(100% + var(--spacing-sm));
  }
`;
const Wrapper = styled.div`
  background-color: var(--bg-100);

  width: 100%;
  max-width: 400px;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  box-shadow: var(--shadow-large);
  display: flex;
  flex-direction: column;
  ${({ $isOpen }) =>
    $isOpen
      ? css`
          animation: ${slideInFromRight} 0.5s ease-out forwards; // Duže trajanje za slide-in
        `
      : css`
          animation: ${slideOutRight} 0.2s ease-in forwards; // Kraće trajanje za slide-out
        `}
  @media (min-width: 768px) and (max-width: 1039px) {
    max-width: var(--sidebar-width);
  }

  @media (min-width: 1040px) {
    position: relative;
    width: 380px;
    max-width: 380px;
    height: auto;
    max-height: 70vh;
    transform: none;
    border-radius: var(--border-radius-large);
    animation: ${(props) => (props.$isOpen ? fadeScaleIn : "none")} 0.18s
      ease-out both;
    display: ${(props) => (props.$isOpen ? "flex" : "none")};
  }
`;

const IconTitle = styled.span`
  font-size: var(--font-size-base);
  font-weight: 500;
  text-transform: capitalize;
  color: var(--text-100);
  display: flex;
  gap: 14px;
  cursor: pointer;

  background-color: var(--bg-200);
  border-radius: var(--border-radius-base);
  padding: var(--spacing-xs) var(--spacing-md);
  border: ${({ $totalfilters }) =>
    $totalfilters > 0
      ? "1px solid var(--primary-100)"
      : "1px solid var(--bg-300)"};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease-in-out;

  &:hover {
    border-color: var(--primary-200);
  }
`;
const MenuTitle = styled.span`
  font-size: var(--font-size-base);
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-100);
`;
const XDiv = styled.div`
  padding: 0 var(--spacing-md);
  height: var(--navbar-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--bg-200);
`;

const SvgContainer = styled.div`
  height: var(--navbar-height);
  width: var(--navbar-height);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.15s ease-in-out;

  &:hover,
  &:focus-visible {
    background-color: var(--bg-200);
  }
`;
const XRight = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
`;
const ClearButton = styled.button`
  background: none;
  border: none;
  color: var(--primary-100);
  font-size: var(--font-size-small);
  font-weight: 600;
  padding: var(--spacing-xs);

  &:hover {
    background: none;
    text-decoration: underline;
  }
`;
const MiddleDiv = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;
const BottomBar = styled.div`
  flex: 0 0 auto;
  width: 100%;
  padding: var(--spacing-sm) 0;
  background-color: var(--bg-100);
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--bg-300);
`;
const BottomWrapper = styled.div`
  width: 92%;
`;
const SelectedFilterNumber = styled.div`
  position: absolute;
  right: 0;
  top: -10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 2px;
  background-color: var(--primary-100);
  font-size: var(--font-size-small);
  color: var(--bg-100);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const nicotineRanges = [
  { label: "0-5 mg", range: [0, 5] },
  { label: "5-9 mg", range: [5, 9] },
  { label: "9-12 mg", range: [9, 12] },
  { label: "12-15 mg", range: [12, 15] },
  { label: "15-17 mg", range: [15, 17] },
  { label: "17-65 mg", range: [17, 65] },
];

const Filter = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [shouldBeVisible, setShouldBeVisible] = useState(false);
  const { products, setFilteredProducts, filteredProducts } =
    useContext(ProductContext);

  // Stanje za selektovane filtere - podignuto ovde da IconTitle badge i
  // "Clear Filters" mogu stvarno da rade (ranije su bili hardkodovani/no-op
  // jer je ovo stanje ranije živelo unutar FilterSection-a, van domašaja).
  const [selectedCategories, setSelectedCategories] = useState(new Set());
  const [selectedFormats, setSelectedFormats] = useState(new Set());
  const [selectedNicotineRanges, setSelectedNicotineRanges] = useState(
    new Set()
  );
  const [filterOutOfStock, setFilterOutOfStock] = useState(false);

  const applyFilters = (categories, formats, nicotineRange, outOfStock) => {
    const nicotineRangesArray = Array.from(nicotineRange);

    const filtered = products.filter((product) => {
      const isInCategory =
        categories.size === 0 || categories.has(product.category_name);
      const isInFormat = formats.size === 0 || formats.has(product.format);
      const isInNicotineRange =
        nicotineRange.size === 0 ||
        nicotineRangesArray.some((label) => {
          const item = nicotineRanges.find((nr) => nr.label === label);
          const [min, max] = item ? item.range : [0, 100];
          return product.nicotine >= min && product.nicotine <= max;
        });
      const isInStock = !outOfStock || product.is_in_stock === "in_stock";

      return isInCategory && isInFormat && isInNicotineRange && isInStock;
    });

    setFilteredProducts(filtered);
  };

  useEffect(() => {
    applyFilters(
      selectedCategories,
      selectedFormats,
      selectedNicotineRanges,
      filterOutOfStock
    );
  }, [filterOutOfStock, products]);

  const handleCategoryChange = (category) => {
    const updatedCategories = new Set(selectedCategories);
    if (updatedCategories.has(category)) {
      updatedCategories.delete(category);
    } else {
      updatedCategories.add(category);
    }
    setSelectedCategories(updatedCategories);
    applyFilters(updatedCategories, selectedFormats, selectedNicotineRanges, filterOutOfStock);
  };

  const handleFormatChange = (format) => {
    const updatedFormats = new Set(selectedFormats);
    if (updatedFormats.has(format)) {
      updatedFormats.delete(format);
    } else {
      updatedFormats.add(format);
    }
    setSelectedFormats(updatedFormats);
    applyFilters(selectedCategories, updatedFormats, selectedNicotineRanges, filterOutOfStock);
  };

  const handleNicotineRangeChange = (range) => {
    const updatedRanges = new Set(selectedNicotineRanges);
    if (updatedRanges.has(range.label)) {
      updatedRanges.delete(range.label);
    } else {
      updatedRanges.add(range.label);
    }
    setSelectedNicotineRanges(updatedRanges);
    applyFilters(selectedCategories, selectedFormats, updatedRanges, filterOutOfStock);
  };

  const handleFilterOutOfStock = (newState) => {
    setFilterOutOfStock(newState);
  };

  const handleResetFilters = () => {
    setSelectedCategories(new Set());
    setSelectedFormats(new Set());
    setSelectedNicotineRanges(new Set());
    setFilterOutOfStock(true);
    applyFilters(new Set(), new Set(), new Set(), true);
  };

  const totalSelectedFilters =
    selectedCategories.size + selectedFormats.size + selectedNicotineRanges.size;

  useEffect(() => {
    if (isOpen) {
      setShouldBeVisible(true);
    } else {
      const timer = setTimeout(() => {
        setShouldBeVisible(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Na desktopu je panel usidren za dugme (position: absolute) i nije
  // sticky, pa bi skrolovanjem "pobegao" od dugmeta i eventualno preplivao
  // preko fiksiranog header-a. Umesto da se rvemo sa z-indexom u odnosu na
  // header, jednostavno zatvorimo panel čim korisnik počne da skroluje.
  useEffect(() => {
    if (!isOpen) return;
    const handleScroll = () => setIsOpen(false);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <RelativeAnchor>
      <IconTitle onClick={toggleMenu} $totalfilters={totalSelectedFilters}>
        {t("FILTER.TITLE")}
        {totalSelectedFilters > 0 && (
          <SelectedFilterNumber>
            {totalSelectedFilters > 10
              ? totalSelectedFilters
              : `0${totalSelectedFilters}`}
          </SelectedFilterNumber>
        )}
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_672_13136)">
            <path
              d="M10 4.99992C10 5.44195 10.1756 5.86587 10.4882 6.17843C10.8007 6.49099 11.2246 6.66659 11.6667 6.66659C12.1087 6.66659 12.5326 6.49099 12.8452 6.17843C13.1577 5.86587 13.3333 5.44195 13.3333 4.99992C13.3333 4.55789 13.1577 4.13397 12.8452 3.82141C12.5326 3.50885 12.1087 3.33325 11.6667 3.33325C11.2246 3.33325 10.8007 3.50885 10.4882 3.82141C10.1756 4.13397 10 4.55789 10 4.99992Z"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.33301 5H9.99967"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.333 5H16.6663"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 9.99992C5 10.4419 5.17559 10.8659 5.48816 11.1784C5.80072 11.491 6.22464 11.6666 6.66667 11.6666C7.10869 11.6666 7.53262 11.491 7.84518 11.1784C8.15774 10.8659 8.33333 10.4419 8.33333 9.99992C8.33333 9.55789 8.15774 9.13397 7.84518 8.82141C7.53262 8.50885 7.10869 8.33325 6.66667 8.33325C6.22464 8.33325 5.80072 8.50885 5.48816 8.82141C5.17559 9.13397 5 9.55789 5 9.99992Z"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.33301 10H4.99967"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.33301 10H16.6663"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5 14.9999C12.5 15.4419 12.6756 15.8659 12.9882 16.1784C13.3007 16.491 13.7246 16.6666 14.1667 16.6666C14.6087 16.6666 15.0326 16.491 15.3452 16.1784C15.6577 15.8659 15.8333 15.4419 15.8333 14.9999C15.8333 14.5579 15.6577 14.134 15.3452 13.8214C15.0326 13.5088 14.6087 13.3333 14.1667 13.3333C13.7246 13.3333 13.3007 13.5088 12.9882 13.8214C12.6756 14.134 12.5 14.5579 12.5 14.9999Z"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.33301 15H12.4997"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.833 15H16.6663"
              stroke="var(--text-100)"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_672_13136">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </IconTitle>
      <DesktopClickCatcher $isOpen={isOpen} onClick={toggleMenu} />
      <ContainerX>
        <Container
          onClick={toggleMenu}
          $isOpen={isOpen}
          $shouldBeVisible={shouldBeVisible}
        >
          <Wrapper
            $isOpen={isOpen}
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <XDiv>
              <MenuTitle>{t("FILTER.SELECTED_FILTERS")}</MenuTitle>
              <XRight>
                {totalSelectedFilters > 0 && (
                  <ClearButton onClick={handleResetFilters}>
                    {t("FILTER.CLEAR_FILTER")}
                  </ClearButton>
                )}
                <SvgContainer>
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 1024 1024"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={toggleMenu}
                    role="button"
                    tabIndex={0}
                    aria-label={t("ARIA.CLOSE")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        toggleMenu();
                      }
                    }}
                  >
                    <path
                      fill="var(--text-200)"
                      d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
                    />
                  </svg>
                </SvgContainer>
              </XRight>
            </XDiv>
            <MiddleDiv>
              <FilterData
                nicotineRanges={nicotineRanges}
                selectedCategories={selectedCategories}
                selectedFormats={selectedFormats}
                selectedNicotineRanges={selectedNicotineRanges}
                filterOutOfStock={filterOutOfStock}
                onCategoryChange={handleCategoryChange}
                onFormatChange={handleFormatChange}
                onNicotineRangeChange={handleNicotineRangeChange}
                onFilterOutOfStock={handleFilterOutOfStock}
              />
            </MiddleDiv>
            <BottomBar>
              <BottomWrapper>
                <button onClick={toggleMenu}>
                  {t("FILTER.VIEW_ALL_PRODUCTS", {
                    filteredProducts: filteredProducts.length,
                  })}
                </button>
              </BottomWrapper>
            </BottomBar>
          </Wrapper>
        </Container>
      </ContainerX>
    </RelativeAnchor>
  );
};

export default Filter;
